import { CSSProperties } from "react"
import { colors } from "../../assets/variables"

const button: CSSProperties = {
  backgroundColor: colors.mostarda,
  color: 'black',
  textTransform: 'capitalize'
}

export { button }